import XLSX from "xlsx";

export function onExport(workbookName, Datas, survey) { // On Click Excel download button
    Datas.actionPlan = [];
    survey.pages.forEach(page => {
        page.elements.forEach(element => {
            let questionAnswer = survey.data[element.questionId];
            let shouldBeInSpreadSheet = element.required === true && ((questionAnswer === undefined) || (questionAnswer.toLowerCase() === "no"));
            if (shouldBeInSpreadSheet) {
                Datas.actionPlan.push({
                    'Project Name': page.section.replace(/_/g, " ")
                        .replace(/AND/g, "&") + "-" + page.name,
                    'Brief Description': element.title,
                    //'My Answer': questionAnswer === undefined ? "Unanswered" : questionAnswer,
                    'Responsible Party': '',
                    'Start Date': '',
                    'Expected End Date': '',
                    'Comments': ''
                });
            }
        })
    });

    let animalWS = XLSX.utils.aoa_to_sheet([
        ["Napa Green Certified Winery - Action Plan & Timeline"]
    ]);

    /* this array controls the column order in the generated sheet */
    let header = ['Project Name',
        'Brief Description',
        //'My Answer',
        'Responsible Party',
        'Start Date',
        'Expected End Date',
        'Comments'];

    /* add row objects to sheet starting from cell A6 */
    XLSX.utils.sheet_add_json(animalWS,
        Datas.actionPlan, {header: header, origin: "A2"});

    // A workbook is the name given to an Excel file
    let wb = XLSX.utils.book_new(); // make Workbook of Excel

    // add Worksheet to Workbook
    // Workbook contains one or more worksheets
    XLSX.utils.book_append_sheet(wb, animalWS, 'Action Items'); // sheetName is name of Worksheet

    // export Excel file
    XLSX.writeFile(wb, workbookName); // name of the file is 'book.xlsx'

}
